/* eslint-disable no-console */
<template>
    <div>
        <page-header :heading="pageHeader.title"
                     :buttons="pageHeader.buttons" />
        <search-form key="inboxSearch1"
                     :inputs="searchInputs"
                     class="mb-5"
                     @clear="handleClearClick"
                     @search="handleSearchClick"
                     v-model="searchFormValue" />
        <hr />
        <message-list :key="'bucket_message_message_list'"
                      :showTasks="false"
                      :eventTarget="eventTarget"
                      :dataListCols="messageDataListCols"
                      :buttonConfig="buttonConfig"
                      :messages="messages"
                      :pagination="pagination"
                      @message-pagination-click="handlePaginationInput"
                      :windowWidth="windowWidth" />
    </div>
</template>

<script>
    import { mapActions, mapGetters } from "vuex";
    import EventBus from "@/messageEventBus.js";
    import {
        MESSAGES_PAGINATION,
        GET_EMAIL_DOCUMENT,
        GET_EMAIL_DOCUMENT_COMPLETE,
        LINK_MESSAGE_TO_CLAIM,
        LINK_MESSAGE_TO_CLAIM_COMPLETE,
        MESSAGES_COLUMN_CLICK,
        DOWNLOAD_MESSAGE_ATTACHMENT
    } from "@/messageEvents.js";

    import { reportsApiService } from '@/services/reports-api.service.js'

    import SearchForm from '@/components/SearchForm.V2.vue'

    export default {
        name: "MessagesBucket",
        components: {
            SearchForm
        },
        data: () => {
            return {
                pageHeader: {
                    title: 'Message Inbox - Not yet linked to claim',
                },
                claimId: null,
                withoutClaim: true,
                orderBy: 'DocumentDateCreatedUTC',
                sortDir: 'DESC',
                pageSize: 10,
                pageNumber: 1,
                searchFormValue: null,
                windowWidth: 0
            };
        },
        computed: {
            ...mapGetters({
                messageDataListCols: "messageStore/dataListCols",
                messages: "messageStore/messages",
                emailDocument: "messageStore/selectedEmailDocument",
                pagination: "messageStore/pagination"
            }),
            eventTarget() {
                return 'bucket_message_message_list'
            },
            buildParams() {
                let {
                    withoutClaim,
                    orderBy,
                    sortDir,
                    pageSize,
                    pageNumber
                } = this

                let criteria = {}

                if (this.searchFormValue != null) {
                    let { to, from, subject, dateRange } = this.searchFormValue

                    criteria = {
                        to,
                        from,
                        subject
                    }

                    if (dateRange != null && dateRange.id != null) {
                        let rng = this.buildDateRange(dateRange.id)
                        criteria.startDate = rng.startDate
                        criteria.endDate = rng.endDate
                    }
                }

                return {
                    ...criteria,
                    withoutClaim,
                    orderBy,
                    sortDir,
                    pageSize,
                    pageNumber
                }
            },
            buttonConfig() {
                return {
                    reply: {
                        enabled: false
                    },
                    assign: {
                        enabled: true
                    },
                    tag: {
                        enabled: false
                    }
                }
            },
            searchInputs() {

                return [
                    {
                        id: 'from',
                        label: 'From',
                        type: 'text',
                        placeholder: 'From'
                    },
                    {
                        id: 'to',
                        label: 'To',
                        type: 'text',
                        placeholder: 'To'
                    },
                    {
                        id: 'subject',
                        label: 'Subject',
                        type: 'text',
                        placeholder: 'Subject'
                    },
                    {
                        id: 'dateRange',
                        label: 'Date range',
                        type: 'select',
                        options: [
                            {
                                id: 1000,
                                label: 'Today'
                            },
                            {
                                id: 1001,
                                label: 'Last 7 days'
                            },
                            {
                                id: 1002,
                                label: 'Last 4 weeks'
                            }
                        ]
                    }
                ]
            },
            attachmentUrl() {
                return '/api/admin/v1/message/download/'
            }
        },
        methods: {
            ...mapActions({
                loadMessages: "messageStore/fetchMessages",
                getEmailDocument: "messageStore/fetchEmailDocument",
                linkMessageToClaim: "messageStore/linkMessageToClaim",
                resetMessages: "messageStore/resetMessages"
            }),
            handlePaginationInput(payload) {
                if (this.messages && this.messages.length > 0) {
                    let params = { ...this.buildParams, pageNumber: payload };

                    this.pageNumber = payload
                    this.resetMessages()
                    this.loadMessages(params)
                        .then()
                        .catch(error => console.log("error2: ", error))
                        .finally(() => {
                            //console.log("all done!");
                        });
                }
            },
            handleSortClick(col) {
                console.log('handleSortClick: ', col)
                switch (col.key) {
                    case '"documentDateCreatedDisplay"':
                        this.orderBy = 'DocumentDateCreatedUTC'
                        break;
                    case '"subject"':
                        this.orderBy = 'Subject'
                        break;
                    case '"from"':
                        this.orderBy = 'From'
                        break;
                }
                if (this.sortDir == null || this.sortDir == 'ASC') {
                    this.sortDir = 'DESC'
                } else {
                    this.sortDir = 'ASC'
                }
                this.resetMessages()
                this.loadMessages(this.buildParams)
                    .then()
                    .catch(error => console.log("error2: ", error))
                    .finally(() => {
                        //console.log("all done!");
                    });
            },
            handleResize() {
                this.windowWidth = window.innerWidth;
            },
            handleClearClick() {
                this.searchFormValue = null
                this.pageNumber = 1
                this.resetMessages()
                this.loadMessages(this.buildParams)
                    .then()
                    .catch(error => console.log("error2: ", error))
                    .finally(() => {
                        //console.log("all done!");
                    });
            },
            handleSearchClick() {
                this.resetMessages()
                this.pageNumber = 1
                this.loadMessages(this.buildParams)
                    .then()
                    .catch(error => console.log("error2: ", error))
                    .finally(() => {
                        //console.log("all done!");
                    });
            },
            buildDateRange(id) {

                let formatDate = (dte) => {

                    if (!(dte instanceof Date)) {
                        dte = new Date()
                    }

                    return dte.getFullYear() + '-' + String(dte.getMonth() + 1).padStart(2, '0') + '-' + String(dte.getDate()).padStart(2, '0')
                }

                let today = new Date()
                let startDate = formatDate(today)
                let endDate = startDate + ' 23:59:59'
                switch (id) {
                    case 1001:
                        // eslint-disable-next-line no-case-declarations
                        let dte1 = new Date()
                        dte1.setDate(dte1.getDate() - 7)
                        startDate = formatDate(dte1)
                        break;
                    case 1002:
                        // eslint-disable-next-line no-case-declarations
                        let dte2 = new Date()
                        dte2.setDate(dte2.getDate() - 28)
                        startDate = formatDate(dte2)
                        break;
                    default:
                    //startDate = startDate
                }
                return { startDate, endDate }
            },
        },
        created() {
            window.addEventListener("resize", this.handleResize);
            this.handleResize();

            //window.onbeforeunload = confirmExit;
            //function confirmExit() {
            //    return "Changes that you have made may not be saved.";
            //}
        },
        mounted() {
            EventBus.$on(GET_EMAIL_DOCUMENT + '_' + this.eventTarget, payload => {
                console.log(GET_EMAIL_DOCUMENT + ": ", payload);
                this.getEmailDocument(payload.documentId)
                    .then(
                        response => {
                            EventBus.$emit(GET_EMAIL_DOCUMENT_COMPLETE + '_' + payload.id, response.data);
                        },
                        error => reject(error)
                    )
                    .catch(error => console.log(error));
            });

            EventBus.$on(LINK_MESSAGE_TO_CLAIM + '_' + this.eventTarget, payload => {
                
                let params = { ...this.buildParams };

                this.linkMessageToClaim(payload)
                    .then(response => {
                        this.loadMessages(params)
                            .then()
                            .catch(error => console.log("error2: ", error))
                            .finally(() => {
                                
                            });
                        EventBus.$emit(LINK_MESSAGE_TO_CLAIM_COMPLETE + '_' + payload.messageId, response);
                    })
                    .catch(error => {
                        
                    })
                    .finally(() => {
                        
                    });
            });

            EventBus.$on(MESSAGES_PAGINATION + '_' + this.eventTarget, this.handlePaginationInput);

            EventBus.$on(MESSAGES_COLUMN_CLICK + '_' + this.eventTarget, this.handleSortClick);

            EventBus.$on(DOWNLOAD_MESSAGE_ATTACHMENT + '_' + this.eventTarget, payload => {
                reportsApiService.getDownloadKey()
                    .then(response => {
                        window.open(
                            this.attachmentUrl + payload + '/' + response.data,
                            '_blank'
                        )
                    })
            })

            let params = { ...this.buildParams };

            this.resetMessages()
            //this.loadMessages(params)
            //    .then()
            //    .catch(error => console.log("error2: ", error))
            //    .finally(() => {
            //        console.log("all done!");
            //    });
        },
        beforeDestroy() {
            this.resetMessages()
            EventBus.$off(GET_EMAIL_DOCUMENT + '_' + this.eventTarget)
            EventBus.$off(LINK_MESSAGE_TO_CLAIM + '_' + this.eventTarget)
            EventBus.$off(MESSAGES_PAGINATION + '_' + this.eventTarget)
            EventBus.$off(MESSAGES_COLUMN_CLICK + '_' + this.eventTarget)
        },
        destroyed() {
            window.removeEventListener("resize", this.handleResize);
            //window.onbeforeunload = null;
        }
    };
</script>

